import { render, staticRenderFns } from "./syncro-send-company-widget.vue?vue&type=template&id=91de7f9a&scoped=true&"
import script from "./syncro-send-company-widget.vue?vue&type=script&lang=js&"
export * from "./syncro-send-company-widget.vue?vue&type=script&lang=js&"
import style0 from "./syncro-send-company-widget.vue?vue&type=style&index=0&lang=css&"
import style1 from "./syncro-send-company-widget.vue?vue&type=style&index=1&id=91de7f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91de7f9a",
  null
  
)

export default component.exports